import { render, staticRenderFns } from "./ProductPostingList_CTVOnly.vue?vue&type=template&id=b444a9b8&scoped=true"
import script from "./ProductPostingList_CTVOnly.vue?vue&type=script&lang=js"
export * from "./ProductPostingList_CTVOnly.vue?vue&type=script&lang=js"
import style0 from "./ProductPostingList_CTVOnly.vue?vue&type=style&index=0&id=b444a9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b444a9b8",
  null
  
)

export default component.exports